// extracted by mini-css-extract-plugin
export default {"container":"empty-clips-state_container__QGE+9"};